module.exports = __webpack_public_path__ + "static/media/wrecked-iphone.ea25f706.jpg";